import {
  mergeClasses,
  useTabListStyles_unstable,
} from "@fluentui/react-components";
import type { TabListState } from "./TabList.types";

export const useTabListCustomStyles = (state: TabListState): TabListState => {
  state.root.className = mergeClasses(state.root.className);
  return state;
};

export const useTabListStyles: (state: TabListState) => TabListState = (
  state
) => {
  useTabListCustomStyles(state);

  useTabListStyles_unstable(state);

  return state;
};
